import WarehouseDataState from "@crescentParts/Store/Data/WarehouseData/WarehouseDataState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

const savedWarehouse = typeof window !== "undefined" ? localStorage.getItem("selectedWarehouseForInventory") : null;

const initialState = {
    warehouseData: null,
    selectedWarehouse: "",
    selectedWarehouseForInventory: savedWarehouse ?? "",
    isTrainingProductInCart: false,
};

const reducer = {
    "Custom/WarehouseData/setWarehouseData": (draft: Draft<WarehouseDataState>, action: { warehouseData: [] }) => {
        draft.warehouseData = action.warehouseData;
    },
    "Custom/WarehouseData/setSelectedWarehouse": (draft: Draft<WarehouseDataState>, action: { param: string }) => {
        draft.selectedWarehouse = action.param;
    },
    "Custom/WarehouseData/setSelectedWarehouseForInventory": (
        draft: Draft<WarehouseDataState>,
        action: { param: string },
    ) => {
        draft.selectedWarehouseForInventory = action.param;
    },
    "Custom/WarehouseData/setIsTrainingProductInCart": (
        draft: Draft<WarehouseDataState>,
        action: { param: boolean },
    ) => {
        draft.isTrainingProductInCart = action.param;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
